import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo2",
  "use": "icon-icon-todo2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo2\"><path d=\"M700.175059 412.912941H324.367059L476.461176 195.764706H548.141176l152.033883 217.20847z m53.970823 0L602.051765 195.764706h74.571294c12.468706 0 24.395294 5.300706 32.768 14.576941l182.874353 202.631529H754.145882z m-185.765647 405.985883l208.896-361.773177h131.433412a44.032 44.032 0 0 1-11.685647 22.648471l-328.643765 339.124706z m157.876706-361.773177l-213.353412 369.543529L299.489882 457.185882h426.767059zM462.727529 828.235294L125.108706 479.774118a43.971765 43.971765 0 0 1-11.745882-22.648471h135.107764l214.256941 371.109647zM270.396235 412.912941H129.867294l182.814118-202.571294a44.212706 44.212706 0 0 1 32.828235-14.576941h76.980706L270.456471 412.973176z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo2.svg
// module id = +q4U
// module chunks = 3